
import React, { useState, useRef, useEffect } from "react";
import ReactDOM from "react-dom";
import "./Tooltip.scss";

export function Tooltip({ triggerContent, tooltipContent, ariaLabel }) {
  const [visible, setVisible] = useState(false);
  const [coords, setCoords] = useState({ top: 0, left: 0 });
  const [position, setPosition] = useState("bottom");
  const tooltipId = useRef(`tooltip-${Math.random().toString(36).substr(2, 9)}`).current;
  const tooltipRef = useRef(null);
  const triggerRef = useRef(null);
  
  const handleShow = () => setVisible(true);
  const handleHide = () => setVisible(false);

    useEffect(() => {
        if (visible && triggerRef.current) {
          const rect = triggerRef.current.getBoundingClientRect();
          const spaceBelow = window.innerHeight - rect.bottom;
          const spaceAbove = rect.top;
          const newPosition = spaceBelow < 150 && spaceAbove > spaceBelow ? "top" : "bottom";
          setPosition(newPosition);
          setCoords({
            top:
              newPosition === "bottom"? rect.bottom + window.scrollY + 8 : rect.top + window.scrollY - 8, 
              left: rect.left + window.scrollX + rect.width / 2
          });
        }
      }, [visible]);

    useEffect(() => {
      if (visible && tooltipRef.current) {
        const tooltipWidth = tooltipRef.current.offsetWidth;
        const tooltipHeight = tooltipRef.current.offsetHeight;
        setCoords((prev) => ({
          top: position === "bottom" ? prev.top : prev.top - tooltipHeight - 8,
          left: prev.left - tooltipWidth / 2
        }));
      }
    }, [visible, position]);

useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Escape") setVisible(false);
    };
    if (visible) document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [visible]);

const tooltipPortal =
    visible &&
    ReactDOM.createPortal(
      <div
        ref={tooltipRef}
        id={tooltipId}
        role="tooltip"
        aria-hidden={!visible}
        className={`tooltip-content ${position} ${visible ? "visible" : ""}`}
        style={{
          position: "absolute",
          top: coords.top,
          left: coords.left,
          zIndex: 9999
        }}
      >
        <div className="tooltip-arrow"></div>
        {tooltipContent}
      </div>,
      document.body
    );

  return (
    <>
      <button
        className="tooltip-trigger"
        aria-describedby={visible ? tooltipId : undefined}
        aria-expanded={visible}
        aria-label={ariaLabel}
        onFocus={handleShow}
        onBlur={handleHide}
        onMouseEnter={handleShow}
        onMouseLeave={handleHide}
        onClick={handleShow}
        ref={triggerRef}
      >
        {triggerContent}
      </button>

      {tooltipPortal}
    </>
  );
}
